import { TranslationLanguagePicker } from "@redotech/redo-merchant-app-common/components/translations/translation-language-picker";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import { memo } from "react";
import { StepTranslationElement } from "./step-translations";
import { TRANSLATABLE_LANGUAGES } from "./translatable-languages";
import { useStepTranslationLanguages } from "./use-step-translation-languages";

/**
 * Per-step language selector: adding a language batch-generates AI
 * translations for every translatable field on the step.
 */
export const StepTranslationLanguages = memo(function StepTranslationLanguages({
  elements,
  flowType,
  canEdit,
}: {
  elements: StepTranslationElement[];
  flowType: FlowType;
  canEdit: boolean;
}) {
  const {
    enabled,
    elementIds,
    loadFailed,
    loading,
    mutating,
    selected,
    pendingLanguage,
    staleLanguages,
    addLanguage,
    requestRemoval,
    languageToRemove,
    removalCount,
    removalPending,
    confirmRemoval,
    cancelRemoval,
  } = useStepTranslationLanguages({ elements, flowType });

  if (!enabled || !elementIds.length) {
    return null;
  }
  return (
    <TranslationLanguagePicker
      canEdit={canEdit}
      languages={TRANSLATABLE_LANGUAGES}
      languageToRemove={languageToRemove}
      loadFailed={loadFailed}
      loading={loading}
      mutating={mutating}
      onAdd={addLanguage}
      onCancelRemoval={cancelRemoval}
      onConfirmRemoval={confirmRemoval}
      onRequestRemoval={requestRemoval}
      pendingLanguage={pendingLanguage}
      removalCount={removalCount}
      removalPending={removalPending}
      removalScope="step"
      selected={selected}
      staleLanguages={staleLanguages}
    />
  );
});
